export class UserModel {
  constructor(data = {}) {
    this.uid = data.uid || ''
    this.properties = {
      name: data.properties?.name || '',
      date: data.properties?.date || null,
      month: data.properties?.month || null,
      year: data.properties?.year || null,
      timezone: data.properties?.timezone || '',
      address: data.properties?.address || '',
      latitude: data.properties?.latitude || null,
      longitude: data.properties?.longitude || null,
      guessCountry: data.properties?.guessCountry || 'unknown',
      hours: data.properties?.hours || 0,
      minutes: data.properties?.minutes || 0,
      seconds: data.properties?.seconds || 0,
      gender: data.properties?.gender || 'prefer_not_to_say',
      familiarity: data.properties?.familiarity || ''
    }
    this.createdAt = data.createdAt || null
  }

  static invalidUser() {
    return new UserModel()
  }
} 